var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bb-onboarding"},[_c('div',{staticClass:"bg-cercles bb-onboarding__container"},[_c('OnboardingStepEcommerceBirthdateContent')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }